<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M10.0013 8.7526C11.8423 8.7526 13.3346 7.26022 13.3346 5.41927C13.3346 3.57832 11.8423 2.08594 10.0013 2.08594C8.16035 2.08594 6.66797 3.57832 6.66797 5.41927C6.66797 7.26022 8.16035 8.7526 10.0013 8.7526Z"
      fill="currentColor"
    />
    <path
      d="M10.0013 17.9206C13.223 17.9206 15.8346 16.4282 15.8346 14.5872C15.8346 12.7463 13.223 11.2539 10.0013 11.2539C6.77964 11.2539 4.16797 12.7463 4.16797 14.5872C4.16797 16.4282 6.77964 17.9206 10.0013 17.9206Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProfileIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>